import React from 'react'
import RoutedWizard from 'core/routing/routed-wizard'
import { THEMING } from 'core/routing/constants'
import Theming from '.'

const router = <RoutedWizard path={THEMING}>{Theming}</RoutedWizard>

export default router
